import * as yup from 'yup';

import { Model as RoomModel } from 'models/room/interface';
import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape, ERROR } from '../validation';
import * as Pagination from '../pagination';
import { ROOM_STATUS } from 'constants/index';

export type PaginationParams = Omit<Pagination.Params<Omit<RoomModel, '_id'>, null>, 'sort'> & {
  status: ROOM_STATUS[];
  dateFrom: string;
  dateTo: string;
  search: string;
  listenersType: string;
  category: string;
  isConstantRoom: string;
  cancelationReason?: string;
  host: string[];
  sort: {
    field: keyof Omit<RoomModel, '_id'> | 'listenersCount' | 'hostName' | 'reactionsCount';
    direction: 'asc' | 'desc';
  };
};
export type PaginationResult = Pagination.Result<RoomModel>;
export type PaginationError = EndpointError;

export const paginationParamsSchema = yup.object().shape({
  page: yup.number().positive(ERROR.INVALID_VALUE).required(ERROR.REQUIRED),
  pageSize: yup.number().positive(ERROR.INVALID_VALUE).required(ERROR.REQUIRED),
  search: yup.string(),
  dateFrom: yup.string(),
  dateTo: yup.string(),
  status: yup.array(yup.string()),
  listenersType: yup.string(),
  category: yup.string(),
  host: yup.array(yup.string()),
  isConstantRoom: yup.string(),
  cancelationReason: yup.string(),
  sort: yup.object().shape({
    field: yup
      .string()
      .oneOf(
        [
          'title',
          'status',
          'isConstantRoom',
          'date',
          'listenersType',
          'category',
          'cancelationReason',
          'listenersCount',
          'reactionsCount',
          'hostName',
        ],
        ERROR.INVALID_VALUE,
      ),
    direction: yup.string().oneOf(['asc', 'desc'], ERROR.INVALID_VALUE),
  }),
} as ValidationShape<PaginationParams>);

export const paginate = endpoint<PaginationParams, PaginationResult, PaginationError>({
  method: 'POST',
  url: () => `/room/paginate`,
});
